export default "__VITE_ASSET__wK9AbJCm__"